/**
 * React Query client — shared across the entire application.
 * Import this to use in QueryClientProvider.
 */

import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000,          // 30 seconds
            gcTime: 5 * 60 * 1000,         // 5 minutes
            retry: (failureCount, error) => {
                // Don't retry on auth errors
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    return false;
                }
                // A 429 is already the server's back-pressure decision. An
                // automatic retry would immediately spend another request in
                // the exhausted bucket; the next normal refresh can retry it.
                if (error?.response?.status === 429) return false;
                // Ordinary transient failures still get two bounded retries.
                return failureCount < 2;
            },
            retryDelay: (attemptIndex, error) => {
                const retryAfter = Number(error?.response?.headers?.['retry-after']);
                const serverDelay = Number.isFinite(retryAfter) ? retryAfter * 1000 : 0;
                return Math.min(30000, Math.max(1000, serverDelay, 1000 * (2 ** attemptIndex)));
            },
            refetchOnWindowFocus: false
        },
        mutations: {
            retry: false
        }
    }
});

export default queryClient;
